// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Notify Client to navigate",
  "1d484fee4a": "Finance, Sales, Project Management, Business Analytics, Product Department, Operations Department, R&D Management, Version Planning, Customer Service Department, Administration Department, Procurement Department, After-sales Management",
  "a2c88dfb79": "Create Your First Team",
  "3cfdcc6086": "Finance, Sales, Project Management/305, HR Administration/306, Operations Department, R&D Management, Version Planning, Customer Service Management/403, Procurement Department, After-sales Management",
  "ac45ec2c05": "Account sign-in verification failed",
  "9aef9b8ccd": "Sign-in account exception. Please sign in again and try again",
  "728dd00f22": "Phone number verification exception. Please sign in using SMS verification code",
  "30dbecd916": "Your information contains sensitive words. Please modify and try again",
  "12ed508d8a": "Your operation is too frequent. Please try again later",
  "952d4a7595": "Account sign-in status exception. Please sign in again and try again",
  "e64bfdeaa4": "Sign-in verification failed. Please try to get SMS verification again",
  "79008a65f1": "This phone number has been added to multiple organizations. Please sign in to the organization or change the phone number",
  "bf242eff42": "Organization name already exists",
  "4f0cdb8374": "Please enter a complete phone number. If you use an overseas phone number, please change it to a domestic number (86+)",
  "46e79ffeff": "Organization creation exception. Please contact official customer service for resolution",
  "f3e18f0341": "Parameter verification failed",
  "503fd1718d": "Failed to send SMS verification code",
  "24b3129f19": "SMS sending is too frequent. Please try again later",
  "1cde3e8245": "Incorrect verification code. Please re-enter",
  "4212ecc031": "Multiple verification errors have occurred. Verification is temporarily restricted. Please try again later",
  "735da9c347": "Organization duplicates check exception. Please contact official customer service for resolution",
  "8731da9615": "Organization name authentication check exception. Please contact official customer service for resolution",
  "62e89b3f16": "Agree to the service agreement",
  "c9b79027e5": "Send verification code",
  "84c1447b9d": "Copied successfully",
  "fba4b0abd0": "Host record",
  "37f5a7cd41": "TXT value",
  "78b12427c9": "Verifying...",
  "59d089837c": "We are currently unable to verify your domain. You may need to wait a little longer for your domain hosting provider to update your information. If there is still no response after some time, please try verifying again or changing the domain.",
  "4a5b7383d1": "Checking domain name",
  "f24a492e40": "verification records. You can close this page and come back later to check.",
  "c697ca5f1a": "WPS Enterprise",
  "ebb01b1740": "Next",
  "30109bf753": "Does your organization have a domain name?",
  "2b3e485b47": "I have an organization domain name",
  "1a7f5eae44": "I do not have an organization domain name",
  "bde15d6d84": "You need to have a domain name (e.g. example.com) to create an organization account for you",
  "07ffb22c90": "Sorry, you need to have a domain name to create an organization account for your organization",
  "de23836563": "Please enter the domain name to create an organization account",
  "287c07944a": "Verify your domain name",
  "3ea2d528d5": "Follow these steps to prove that you are the owner of <b>{domain}</b> and prevent anyone else from registering an organization account using this domain name.",
  "082b18ce56": "a. Open the website of the domain hosting service provider in <b> a new tab </b>, then <b> sign in </b> to your account;",
  "4f7e0841a9": "b. On the website of the domain hosting service provider, redirect to the <b> DNS records section </b>. b. On your website of the domain hosting service provider, the name of DNS records section may vary. It might appear as <b> DNS Management, Name Server Management, Control Panel, or Advanced Settings. </b>",
  "6365ad6e3a": "Next, <b> return here </b>, and then click \"Next\" to add verification records.",
  "8528892080": "Add verification records",
  "7a225304f8": "a. On the DNS page, scroll to the <b>TXT</b> section, and then click the relevant button to add a record;",
  "b3cb7d947c": "b. <b>Copy and paste</b> all the values below into the <b>TXT form</b> on the website of the domain hosting service provider;",
  "47213583bf": "c. <b>Save</b> the record on the website of the domain hosting service provider, <br> then <b>return here</b> and click \"Verify Domain\" below",
  "21486a57cf": "Note: In the Name/Host/Alias field, you can enter \"@\" or leave it blank. The domain hosting provider may also require you to enter your domain name (e.g., <your-domain>.com) in this field. You may be able to determine how to fill in this field according to other DNS records. In the Time to Live (TTL) field, enter \"86400\" or retain the default value.",
  "f1b8edab9c": "Change Domain Name",
  "7c6fc663a8": "Verify Domain Name",
  "b6aee9dc0d": "Domain verification successful",
  "dd4cc429ea": "You have been verified as the owner of",
  "450f5c9230": ", and no one else is allowed to use this domain to register an organization account.",
  "71cbcba755": "Click \"Next\" to complete the creation of the organization account.",
  "f4084f4870": "Please set up your sign-in account",
  "fe3138baec": "Creation Completed",
  "0315cddedb": "Organization created successfully",
  "91454a7f34": "Now sign in to the Admin Console to create organization accounts for your members",
  "366304cde7": "1. Will automatically sign out of the current WPS account",
  "8a9f2a8422": "2. You need to use the organization account {account}@{domain} to sign in to the Admin Console",
  "43e265e998": "Go to sign in to the Admin Console",
  "9240efaaf0": "SMS sent",
  "e424bb9a6d": "Please enter ",
  "d44d581706": "Organization name",
  "aa8679f406": ", 4~30 characters",
  "581bdb1f98": ", cannot contain special symbols \\/:*?\"<>|{}",
  "c13cabb67a": "Email",
  "2b9b429e46": "Your email",
  "5ed834a7df": "Please enter your email",
  "acfd1f02ed": "Please enter a valid email address",
  "31c7c92cca": ", up to 80 characters",
  "3f27cf84b3": "Please enter the verification code",
  "a0ae1f3ec4": "Incorrect verification code. Please re-enter",
  "e5589c5e74": "Your name",
  "69d7bd63f6": ", only Chinese characters, letters, and numbers are allowed",
  "91f008d258": ", up to 8 characters",
  "6ea6c9b39b": "Contact Number",
  "161042c5b7": "Please enter contact number",
  "e6b8eab1cd": "Please enter a contact number, 11 digits",
  "3fd5fbb3cc": "Please enter your domain name",
  "cb5346ba8e": "Please enter a valid organization domain name, 4~30 characters",
  "27928eb7a4": "Account",
  "8e19bd444d": "Please enter the account name for sign-in",
  "7bbbf479dc": "4-20 characters, only digits, letters, or underlines",
  "3d84cae479": "Please enter a valid account/the first character must be a letter or digit",
  "c0d5ece1a7": "Password",
  "f444036fa8": "Please enter the password",
  "b03218d72b": "The password should be 12-16 characters with a combination of uppercase letters, lowercase letters, digits, or symbols",
  "b4ab05df50": "*Someone in your organization has already used your domain name for an organization account. Please contact customer service (400-677-5005) to prove your ownership of this domain",
  "c58876008f": "Copy failed. Please try again",
  "86f73420de": "Invitation Link",
  "a58861962c": "Sorry, your current browser does not support downloading this QR code",
  "228db07f78": "Finance, Sales, Project Management, Business Analytics, Product Department, Operations Department, R&D Management, Version Planning, Customer Service Department, Administration Department, Procurement Department, After-sales Management",
  "93896d7e98": "After creating a team, start collaborating with colleagues",
  "e8f66fb75c": "Finance, Sales, Project Management/305, HR Administration/306, Operations Department, R&D Management, Version Planning, Customer Service Management/403, Procurement Department, After-sales Management",
  "831b73da9b": "The name cannot contain illegal characters and special symbols /\\;:*?\"<>|%&",
  "51ab33b3ee": "Incorrect parameter",
  "a297f9e951": "Organization name already exists",
  "04d60ed5f5": "Cannot use prohibited words",
  "2ff7bef083": "Domain name format error",
  "41e1ba2165": "Failed to verify domain TXT information",
  "50f348caa9": "Duplicate account",
  "9d4c950d65": "This name has already been registered",
  "38cf19ed95": "This organization name already exists",
  "4b426e7c9c": "Organization name",
  "298f880e18": "already exists. It is recommended to provide more information:",
  "1e67dd20b3": "Retrieve organization name",
  "517107cb04": "Use another name",
  "5667081882": "Create with this name",
  "e306a979a6": "Quick fill:",
  "f583db96e0": "*If the organization name is taken, you can",
  "9767148e34": "Please enter the company or organization name, 4-100 characters",
  "e0e0ec159f": "Organization name",
  "5b13d254c0": "This organization name already exists",
  "92027671ec": "Organization Name",
  "36d482a7fb": "Recover Organization Name",
  "79058a7577": "*If the organization name is taken, you can",
  "c96dd48dba": "Organization name",
  "842efad336": "*If you are an employee of the organization, please",
  "860f9bd77b": "WPS Customer Service",
  "5a7ed18daf": "Join the organization",
  "ab470e9ace": "Leave contact information",
  "0a7e0e48a7": "Organization name applying to join:",
  "a8dc318dcc": "Please verify the contact information you entered. The platform customer service will call you later",
  "6ea1f4d7f5": "Submit documents",
  "d439e39f43": "We have received your documents",
  "884653426b": "Customer service will call you within 24 hours. Please pay attention to the call!",
  "2361cb14bf": "Scan the QR code to add online customer service and check the progress",
  "50f45d0031": "Saving failed",
  "fc856d0fd2": "Super Administrator",
  "e16c0676d2": "Administrator",
  "b1d2ddd126": "Ordinary member",
  "9d322cc08d": "The organization name cannot contain special characters \\/:*?\"<>|{}",
  "b583ba7363": "The company name cannot contain special characters \\/:*?\"<>|{}",
  "1d118a9bad": "Name must be 4-100 characters",
  "441b45b1f5": "Name must be 4-100 characters",
  "97457cb1f0": "Organization name has exceeded 100 characters. Please enter an organization name of 4~100 characters",
  "8ce00d3b92": "Organization name has exceeded 100 characters. Please enter an organization name of 4~100 characters",
  "a72778d3de": "Name must be 2-10 characters",
  "79c17db5de": "Name has exceeded 10 characters. Please enter a name of 2~10 characters",
  "482a118202": "Name only supports Chinese characters, digits, English,",
  "9a9be18941": "Please check",
  "e6b7c4aa66": "Online Service Agreement",
  "595023d905": "Create organization",
  "ba8c2df551": "WPS 365 | Sign up for free",
  "d284384975": "Online Service Agreement",
  "5c266d5a84": "the Privacy Policy",
  "fcb92dbcf6": "Cloud Office Service Agreement",
  "2ae7a8a3f7": "Thank you for choosing WPS 365 Cloud Office Service. The following mainly introduces the legal agreements between you and/or the organization you represent and WPS Office regarding registration, subscription, and use of this service.",
  "d30a6983bd": "Please read {0} | {1} | {2}. Click \"Agree\" to accept the terms of the agreement and our services.",
  "263e306ede": "I have read and agree to {0} | {1} | {2}",
  "440129c0f1": "Please enter {0}",
  "8ab916983d": "Organization name",
  "b01d68543b": "Your name",
  "684b30d4e9": "Mobile number",
  "a48427e8e2": "are used to establish a work platform for your organization",
  "3a81b0f1fc": "Make it easier for colleagues to find you in the system for collaborative work",
  "52bc539b6e": "Confirm creation",
  "b2fe245e19": "Create organization/team: File sharing and collaboration",
  "893282d3f7": "Please provide organization information:",
  "cc997bf6aa": "Confirm",
  "50fdde51ac": "{0}, {1}~{2} characters",
  "a19cc5ec18": "{0}, cannot contain special symbols \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, only allow input of Chinese characters, letters, digits",
  "f4080b1431": "{0}, maximum {1} characters",
  "88e59b2d58": "{0}, 11 digits",
  "91d6d4e105": "Please enter the verification code",
  "bec71bde96": "Incorrect verification code. Please re-enter",
  "e20ff8ee19": "{0} required",
  "8dc09d10d7": "Unable to find dwId",
  "a03766ce6c": "School",
  "03542addfe": "Organization",
  "adb8a815d1": "The binding of {0} to the phone number has reached the limit",
  "97a6b66f1d": "The current phone number is already bound to {0}",
  "665e465487": "Unable to create {0}. The current phone number \"<strong>{1}</strong>\" has reached the limit of bound {0} (up to 5 {2} can be bound). You can check the already bound {3} below:",
  "a85b1367ca": "The current phone number \"{0}\" is bound to {1}. You can choose to sign in with an existing {2} or create {3}:",
  "bf992ce17b": "Create {0} using another phone number",
  "395ea04444": "Create {0}",
  "4ce3bb86b3": "The number of {0} added exceeds the limit",
  "df88c4b7a5": "The current phone number \"{0}\" is already bound to the maximum number of {1}",
  "78f7dd59ca": "The current phone number \"{0}\" is bound to the following {1}. You can directly switch to use",
  "8db491a3f8": "Continue to create {0}",
  "83f6d9e1e4": "Try again",
  "1dc5f11612": "or",
  "217d76f53e": "Report a problem",
  "b69a6ea62a": "Please press the left mouse button to scratch out both sides of the shield",
  "3a31f64800": "You have successfully scratched out the shield <br/> Continue with the next step",
  "6a81fcee96": "Loading",
  "e97877a65d": "Oops, the shield is missing <br/> Please",
  "8d85456145": "I have been waiting for too long <br/> Please",
  "77ad847b95": "The network speed is slow <br/> Please",
  "dbd1ae3a34": "You scratched too fast <br/> Please",
  "bd8e05cd53": "Click the button to start smart verification",
  "63d2a8a722": "Verified successfully",
  "73141928ad": "Verification failed. Please click the button to refresh",
  "04856c5c8a": "Smart detection is in progress",
  "52cd9bd26d": "Your operation is not authorized",
  "fd157e8ea8": "Create guide",
  "c6225c5b2b": "Welcome to the enterprise edition",
  "e33423fb1e": "Created successfully",
  "7b0c035999": "WPS Docs Organization Creation Success Page",
  "85db8faae0": "Enterprise Edition Instructions",
  "20591b9b44": "Recover Organization Name",
  "b023d76dc2": "Member Upload Guide",
  "e2f454e095": "Organization of {0}",
  "df466f942b": "Branch",
  "26a7b797c4": "Subcenter",
  "5fc82b360b": "For multi-member cooperation from a organization/company",
  "f2e736d52e": "WPS Enterprise",
  "becc41a35b": "Organization name",
  "74685cdc58": "Name must be 4-100 characters",
  "07b55b1907": "Organization size",
  "77b2f763ad": "Select your organization's size",
  "49d2509109": "Less than 5 people",
  "8db2c9b74a": "6-20 people",
  "a9fb0cf14a": "21-50 people",
  "0fed41f8d3": "51-100 people",
  "fb33f25a04": "101-200 people",
  "3e3ff0f52e": "201-500 people",
  "cd8b51f634": "501-2,000 people",
  "0662fa6eec": "More than 2,000 people",
  "69334dba1a": "Primary business need",
  "79994e749c": "",
  "840a017f38": "Select your top priority to address",
  "f045b05c73": "Please enter your requirements for organization creation",
  "d8efb0b36d": "Other",
  "adcb8fbb0c": "Main mobile number",
  "eb1c73e2ca": "Please enter your main 11-digit mobile number",
  "7f276e7dfa": "Create Account",
  "c391b3eec1": "Failed to send SMS",
  "54f4cb8fa7": "SMS sent",
  "231eb1fa1e": "Organization User_{0}",
  "272b0f9d32": "Organization User_{0}",
  "b209a67331": "Failed to create an organization. Please refresh the page.",
  "acb08d0cc9": "Step three of organization creation",
  "83db361f51": "After creation, trigger the redirect logic",
  "1e930326e3": "handleStep advances to the next step",
  "184df5c725": "saveForm failed",
  "736eab3023": "Submit validation",
  "2db62dc13c": "Validation failed",
  "54fb0afaea": "Validation successful",
  "d39cff3fcf": "Skipping extreme saving only to find the need for verification code",
  "305b777ae5": "Failed to check the name. Enable the \"Organization name already taken\" pop-up and store the name",
  "e57b6686b2": "Check if the authentication subject has been authenticated. Enable the authentication protection prompt pop-up & store the corresponding authentication subject information",
  "f7c86f496d": "Duplicate name creation || Verification code expired. If any of these exist, prevent execution",
  "cb37db4fd4": "handleSubmit failed",
  "243a569fc4": "The name has been registered. Please use another name",
  "196851a3d9": "Organization User_{0}",
  "0c3a3595ff": "Organization User_{0}",
  "a33b41e0f2": "Failed to create an organization. Please refresh the page.",
  "fcce6a7156": "Created successfully",
  "5ec6da58a6": "Notify client",
  "259c9dfa4e": "Professional version logic",
  "864156930f": "VBA logic",
  "7824efd172": "WPS Docs Mobile",
  "52b6cfaaaf": "WPS Client",
  "c7c51beea9": "Education version",
  "8d054d4986": "Default Client",
  "b597e18fb1": "isWps365PcClient and has openurl",
  "b0c13de2a0": "isWps365PcClient or non-client, has openurl",
  "7d0f2ce18c": "isWps365PcClient or non-client, has openurl success callback",
  "e2c5a07df6": "Non-client non-openurl",
  "29e0414d1f": "Non-client non-openurl callback",
  "60861f7d2a": "autoChange is left to the business to switch",
  "7c83140d90": "Visitor status creation. No need to switch accounts through SDK (SDK does not support visitors). Code has successfully switched through the interface",
  "3379b09e59": "Has openurl and uses href to switch",
  "586ff04c22": "Redirect separately",
  "b6c91f218b": "useSuccessSkip failed",
  "47d2f3ba66": "Other",
  "57551f86ce": "Trigger different methods to redirect based on utm_source",
  "64fe3758e2": "Your operation is not authorized",
  "4da3e1262f": "Created successfully. Start the organization office journey",
  "c38dfb8c6c": "Create Your First Team",
  "38dddb483b": "Enter the organization",
  "614d9c91eb": "Invite members to join",
  "97f1eca0aa": "Enter the organization",
  "13a4939e90": "Join organization invitation",
  "a319e4ae0a": "Invite colleagues to join",
  "12e4da6bba": "Invite colleagues immediately",
  "bd885380f6": "Failed to get invitation link",
  "5e626c4063": "SMS sent",
  "3dc09e7cfd": "The number of organization names you have applied to retrieve has reached the limit",
  "48318f41f9": "Invite members to join",
  "45441baac4": "Invite you to join {0} to collaborate together",
  "e5847fbd67": "Copy link, invite members",
  "23101dd40a": "Customizing solutions for you",
  "71bb7e54a8": "Project management",
  "aff37c79cc": "Experience the selected plan",
  "a97b174258": "Invite another <color: red>2</> colleague(s) to join and get the following enterprise benefits for free",
  "253855849f": "Share the invitation link to your work group to invite colleagues",
  "57b0a2a63f": "Copy the link to invite colleagues",
  "71c0a37ee1": "Enter the organization",
  "f848c60e0e": "Invite another <color: red>2</> colleague(s) to join and get the following enterprise benefits for free",
  "664e32b4fe": "Invitation page Enter the organization",
  "872f14403a": "Invite colleagues to join",
  "1880e7deb9": "Invite colleagues immediately",
  "cc2a9aaf82": "Created successfully",
  "02a13e2583": "Invite another <color: red>2</> colleague(s) to join and get the following enterprise benefits for free",
  "5d3593cdce": "Failed to get team information",
  "c025113ea1": "Failed to get invitation link",
  "b83bc1e485": "Invite by link",
  "0996ced9f6": "Sorry, your current browser does not support downloading this QR code",
  "1e88451e31": "Invitation link copied",
  "bb969cabcd": "Copy failed. Please try again",
  "15e1f79c7a": "Apply to join the organization",
  "59c22b4ef8": "Received an invitation link",
  "0f0b392e60": "Create Your First Team",
  "0437d07c43": "Organization name",
  "41800c7bf1": "Please enter the name of creator",
  "1ec5999511": "The name of creator can be up to 8 characters",
  "02da35b4e4": "The name of creator can only contain Chinese characters, letters, and digits",
  "184e9f6616": "Please enter contact number",
  "9b587898ba": "Please enter a contact number in the correct format",
  "e68c164a02": "Please enter your email",
  "0b1de22df7": "Please enter a valid email",
  "61026181ab": "Business license is required",
  "c3847e604e": "File size exceeds 10MB. Please select again",
  "49450f4ec7": "Complaint form for duplicate names is required",
  "39c3b8fa1d": "Submission failed",
  "3ea44d7963": "Upload successfully",
  "5b1aa3c2c4": "Upload failed",
  "7e7f81eaa3": "Upload failed. File is larger than 10 MB",
  "2ff1913de1": "Upload failed. File must be .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Business license is required",
  "66bda65057": "File size exceeds 10MB. Please select again",
  "8f2305a83d": "Complaint form for duplicate names is required",
  "55ff0c8c6e": "Submission failed",
  "8dad6d950d": "Failed to get invitation information.",
  "a5f0ac3a9a": "Created successfully",
  "4f1d069770": "The utm parameters for the invitation page are {0} and name {1}",
  "f9578cfe6d": "The utm parameters for the two-step guide are {0} and name {1}",
  "e10d028405": "Two-step guide pcoffice created",
  "8e22e4fcc4": "Invitation link copied",
  "3f327f9f37": "Copy failed. Please try again",
  "bd1aecb265": "Cancel",
  "b6abf9b19a": "Agree",
  "e910d9cc0f": "Cancel",
  "37ab25522d": "Agree",
  "196b3eb9cf": "Scan to join",
  "2b81c52e20": "Download image",
  "62152fd9f3": "Invite by link",
  "e0a3725651": "Sorry, your current browser does not support downloading this QR code",
  "8b7883b2c7": "Scan to join",
  "9e9a659ed5": "Download Image",
  "0d55065a9a": "Invite by link",
  "487cf6a106": "Sorry, your current browser does not support downloading this QR code",
  "78fd005d1f": "Please enter the phone number",
  "f909563857": "Create using this number",
  "a26a19f139": "Cancel creation",
  "cc004ac9ee": "Phone number",
  "4df8c3c588": "Create a school with another phone number",
  "3151cabb3d": "Create an organization with another phone number",
  "56098a71eb": "Click Smart Verification to send verification code",
  "e96ec218e4": "Please enter the SMS verification code",
  "ce619a0225": "SMS verification code sent to",
  "0e9863aaeb": "Incorrect verification code. Please re-enter",
  "32dc8629e1": "Resend in...seconds",
  "e4eda9add5": "Resend",
  "b007977564": "Failed to get approval information",
  "d8852ffc9c": "Non-administrator access",
  "8a733a2574": "Mobile access",
  "9e8c152c4f": "PC access",
  "2265a55e93": "Agree to the service agreement",
  "80dabe5aa3": "Create guide",
  "7deee8bf5a": "Two-step guide docsWeb created",
  "69eb501ecb": "Your complaint has expired and cannot be accessed",
  "aa1d9d98ad": "Insufficient permissions. Cannot access",
  "fdf2fe129e": "Create organization",
  "7f0ca0df6b": "WPS 365 | Sign up for free",
  "cc6ac2a93c": "Two-step guide Base mounted",
  "5d6c570bf0": "Two-step guide beforeunload",
  "a4eb8a192d": "Teams being created by everyone",
  "4912e16a9d": "Organization name has been retrieved",
  "41c4e87ef2": "You can click the link",
  "5e630930c0": "Recreate the organization",
  "436a563524": "If you have already created an organization, you can refer to",
  "0b6e7cbe7f": "How to Modify the Organization Name",
  "cb7bce0775": "tutorial to modify the organization name",
  "3feadd3040": "Current version is too low to use the organization",
  "3cf23de936": "Your software version is too low to use organization features. Please go to the app store to update your software version!",
  "a1c5d5d202": "I see",
  "e50183bd00": "WPS Cloud Documents",
  "e5031ab679": "Secure, Synchronized, Collaborative",
  "c870026dfc": "Sign in with WeChat",
  "e7647cd875": "Mobile phone or Email",
  "07b380074b": "Sign in with QQ",
  "67921724dd": "Other Methods",
  "254da8a9f5": "The number of organizations joined/created has reached the limit",
  "3648e4811b": "Enter WPS Docs",
  "dcd102b346": "Create a custom team",
  "8b9b258cbf": "Enter team name here",
  "19bb6e0ded": "WPS members enjoy",
  "2d9fe8d938": "Office privileges are designed to help you solve everyday document challenges. Come and try now!",
  "e8c1caa649": "Upload from local",
  "03641083a3": "Move from \"Personal Documents\"",
  "eecd3ab9b5": "Next time",
  "13b447b3a8": "Refresh",
  "3c2fc507fc": "Current version is too low to use the organization",
  "c3615d8134": "Your software version is too low to use organization features. Please go to the official website to update your software version!",
  "644a36e05b": "Go to update.",
  "d435105f21": "The number of organizations joined/created has reached the limit",
  "73a286ceb0": "Enter WPS Docs",
  "c2cec645c0": "Cancel",
  "b5f5b83c0f": "Agree",
  "76ec352da5": "Invite colleagues by scanning code",
  "6a509e4487": "Download QR Code",
  "940cc4a546": "Unable to create an organization",
  "78b2a62ea5": "Enter the existing organization or create a new one",
  "3a6da7f6f9": "The current phone number is already bound to the maximum number of organizations (up to 5 organizations)",
  "93bab52870": "The current phone number is already bound to an organization. You can select an existing organization to sign in:",
  "ce6e0adaf2": "You can choose to enter the following bound organizations:",
  "1ce200a92b": "Select",
  "bb91ef2999": "Create a new organization",
  "024e4a91e5": "Organization name is already registered",
  "eb089a23a0": "This organization name is already registered:",
  "7646558701": "Administrator:",
  "1d9c02bd33": "Registration time:",
  "919fc7805f": "It is recommended that you try to find and contact the above colleagues.",
  "0ca71a9344": "You can also temporarily use another name to create an organization (which can be changed later) and then submit a complaint.",
  "e83a244e90": "Click to learn how to appeal.",
  "d22bedfb21": "Confirm",
  "907b78b6e5": "Enter a name for your workgroup or team",
  "7195b0ac1e": "Suggested team names",
  "60ed4f915e": "Next",
  "f5ba8dfb7b": "Skip For Now",
  "5c44a3ef68": "Up to 100 characters",
  "130c53fb20": "The name cannot contain illegal characters and special symbols /\\;:*?\"<>|%&",
  "e832d41acc": "Two-step guide Skip",
  "80d9cf7177": "Two-step guide Refresh",
  "0aebf80435": "Two-step guide Click label",
  "e74f515977": "Two-step guide handleSubmit",
  "308d2a53c9": "Two-step guide createGroup",
  "dda2ed7e18": "Two-step guide Failed to create team",
  "ded3c35500": "Failed to create the team",
  "4f18031bc1": "Two-step guide createTemplate",
  "091e5cefcc": "Two-step guide createTemplate error",
  "58cf4e00f0": "Verification code",
  "92abbf0385": "Send verification code",
  "f0f9976ef9": "Please enter the phone number",
  "a4ce99b1df": "Verification code",
  "39d36e0f9f": "Confirm",
  "0fd8a01938": "Send",
  "9048a4e842": "Phone number",
  "9afa1091eb": "Resend",
  "58d787001f": "Create a school with another phone number",
  "450905a265": "Create an organization with another phone number",
  "f7386de3c6": "Drop-down selection",
  "27aa05a92c": "Agree to the service agreement",
  "80af61cb57": "Return to the previous page",
  "50149b8d4f": "Applicant name",
  "e6756f8749": "Enter your name",
  "3cbd51a2b1": "Name must be at least 2 characters. Please enter a name of 2~10 characters",
  "4f79b4813f": "Name only supports Chinese characters, digits, English,",
  "71d3e75983": "Main mobile number",
  "afe5149035": "Please enter your main mobile number",
  "1e9270b50f": "Please enter your main mobile number, 11 digits",
  "ff5dc98dfb": "Skip",
  "165be2ab43": "Return to the previous step",
  "231d8a335a": "Agree to the service agreement",
  "1cad008ffc": "The organization name {0} has been registered. Please use another name",
  "c6e274fcab": "Agreement confirmation",
  "b9352504bb": "Disable agreement pop-up",
  "8409e99ad0": "Enable agreement pop-up",
  "1593c6dd95": "Submit",
  "4f44a9de22": "Open SMS verification",
  "26b70c68b8": "Skip and go directly to the organization",
  "a8bebcb302": "Return to the previous page",
  "c800b4fec5": "Invitation page Base Mounted",
  "38b396d5b0": "Invitation page docsWeb Mounted",
  "2eb7f9a9f1": "Your complaint has been successfully submitted",
  "2c6f3590fb": "We expect to send the processing result to your email within 3 working days",
  "2ea3eff708": "Please pay attention to check.",
  "53acfba22c": "Invite colleagues immediately",
  "4e6d282f4f": "Join organization invitation",
  "5f72f4b936": "Invite colleagues immediately",
  "e5383077ba": "Recover Organization Name",
  "06e3fa2350": "Upon inquiry,",
  "653a263b5e": "the creator of is",
  "769f57269f": "The phone number of the creator is",
  "09a224695e": "Please confirm whether the organization creator is your colleague",
  "3beda6c149": "·If it is your colleague, you can contact him to",
  "5c74dd10d1": "change the organization name or transfer the super administrator.",
  "da504edb0f": "·If it is not your colleague, you can click the button below to continue retrieving the organization name.",
  "39194faaf1": "Continue to retrieve the organization name",
  "e22b829e90": "Copied successfully",
  "6e1b44752a": "TXT value",
  "79881b1d7a": "Invite colleagues immediately",
  "a5344a45f9": "Click the top right corner, and select [Send to Friends]",
  "a4954a5b08": "Invite colleagues immediately",
  "8e3a1625fb": "Recover Organization Name",
  "bf8b8c7005": "Upload the enterprise business license",
  "bfd44a66c9": "Click to select",
  "d503f20925": "Please upload a scanned copy or photo of the enterprise business license",
  "cbebe043c5": "Support JPG, JPEG, PNG, BMP, and PDF formats, not exceeding 10 MB.",
  "9650b96d7d": "Upload the duplicate name complaint information form",
  "c3b8ae46d3": "Please upload a scanned copy or photo of the duplicate name complaint information form",
  "9e325a9e09": "Download the information form template",
  "a4711aae88": "Submit application",
  "3a5cc1441e": "Verifying...",
  "0bd7bf8511": "We are currently unable to verify your domain. You may need to wait a little longer for your domain hosting provider to update your information. If there is still no response after some time, please try verifying again or changing the domain.",
  "fae48d554b": "Checking domain name",
  "5e1779a0ca": "verification records. You can close this page and come back later to check.",
  "ca85f8b836": "Welcome to the enterprise edition",
  "2570e0f00b": "Sign-in failed.",
  "40d16a007e": "Your personal account has been automatically bound",
  "81376b92e4": "Your personal account sign-in method {0} has been automatically bound. Please sign in again to switch to your organization account.",
  "ba679ba739": "Got it. Go to sign in",
  "c05f64c6c6": "Automatically go to sign in after {0}",
  "c329ccef3a": "Sign-in failed.",
  "e370f9afb1": "Your personal account has been automatically bound",
  "410cf42585": "Switch to {0}'s sign-in method. Please sign in again to switch to the company account.",
  "062d48aece": "Got it. Go to sign in",
  "95a105d412": "Go to sign in after {0}",
  "2d000d5a6d": "Send the sharing link to members. Members can apply to join after opening",
  "8861b6e90d": "Enter the organization",
  "25b9f72fda": "Page parameter error",
  "1c76123efc": "Failed to get invitation link",
  "6caba48b76": "Skip",
  "f66379c650": "Page parameter error",
  "c45021de2a": "Creation failed.",
  "011d470126": "The platform continuously protects your information security",
  "f1a44d9151": "The platform has obtained the ISO27001 and ISO27701 certifications issued by the international BSI, and has passed the security qualification assessment of the National Cybersecurity Classified Protection Level 3--",
  "255ea5dff7": "Security White Paper",
  "bb55b124f2": "Create an organization display",
  "61e24974a3": "Create an organization to access policy content",
  "bfdf78febe": "Next, complete the information",
  "c4aa2d2d60": "Enter the workgroup or project name",
  "b69765ab64": "Teams being created by everyone",
  "9657d9408b": "Refresh",
  "e21da8c16a": "Next",
  "224ef5cc9f": "Skip For Now",
  "641f58c8f6": "The current organization does not support members in creating teams. Please contact the administrator to create one",
  "efea622752": "Copy the link to invite colleagues",
  "fd5b40a9fd": "You are invited to join \"{0}\" and collaborate with us",
  "b04dd2f10a": "Invitation link copied",
  "d1606a1b1a": "Copy failed. Please try again",
  "0d59f3db83": "Enter the project department or team, such as \"Sales\"",
  "9429513d34": "No need for guidance",
  "b54a20b1ff": "Creation failed",
  "093fa0fb74": "Signing in and authorizing...",
  "b383b136f4": "Organization project creation and initialization",
  "b6b21b388b": "Organization name is already registered",
  "285dc68c10": "This organization name is already registered:",
  "1bf685b89d": "Administrator:",
  "7b4297edcc": "Registration time:",
  "fa51ea19fc": "It is recommended that you try to find and contact the above colleagues.",
  "e3678a996d": "You can also temporarily use another name to create an organization (which can be changed later) and then submit a complaint.",
  "5969bc8071": "OK",
  "ba4cf699df": "Recover Organization Name",
  "afecee4eb4": "Your name",
  "a8bdebc614": "Enter your name",
  "5bbeb38a66": "Contact Number",
  "b4f7b44b7a": "Please enter your contact number",
  "cac2913686": "Contact email",
  "23d3bb3a42": "Please enter your contact email",
  "ea106a393c": "Upload the enterprise business license",
  "f74131d71e": "Click to select",
  "53749c51c5": "Please upload a scanned copy or photo of the enterprise business license",
  "c00f2ea171": "Support JPG, JPEG, PNG, BMP, and PDF formats, not exceeding 10 MB.",
  "57ec07fa97": "Upload the duplicate name complaint information form",
  "8eb0606e94": "Please upload a scanned copy or photo of the duplicate name complaint information form",
  "f59e76c0b0": "Download the information form template",
  "030bd26fa4": "Submit application",
  "0a602dc727": "Secure data storage",
  "9138f28acf": "File sharing and collaboration",
  "b3a306cf90": "Compliance and legitimation",
  "973c53f725": "It is recommended to modify the name. You can submit organization authentication and update the name after registration",
  "f886f5e92f": "It is recommended to modify the name. You can submit organization authentication and update the name after registration",
  "b8051702a3": "The name contains sensitive words. Please adjust the name or contact customer service",
  "d73881f7d4": "The organization name is protected",
  "dc7e58e320": "The organization name is protected. Verification of the subject's information is required before use. It is recommended to modify the organization name or use it after completing organization authentication after registration.",
  "20c3bc070c": "Confirm",
  "c4278e5f28": "Insufficient permissions",
  "9217efae21": "The account you signed in with has no permission to create. Please contact the salesperson for assistance",
  "52ff08f2ad": "The organization name is protected. Please adjust the organization name",
  "79386ae280": "Please enter a 6-digit verification code",
  "d7b2c5a41b": "Verification code has been sent to",
  "ce2e1c26f7": "(valid for 10 minutes)",
  "59d338903f": "Can retrieve the verification code again after {0} seconds",
  "5aadd14136": "Retrieve verification code again",
  "90f5c93432": "This name has already been registered",
  "1677072f4a": "You can provide more information or register with another name.",
  "3b8459fb1e": "Quick fill:",
  "6f38edbcb1": "Register with this name",
  "8406c81e2d": "Branch",
  "29d323fa85": "Sub-center",
  "4f0e806e02": "Finance",
  "3f935efb6b": "Agree to the terms of service",
  "b42241be05": "Not Now",
  "99de4b33b7": "Agree",
  "7f867e7395": "Create an organization with another phone number",
  "0d51a8f7a6": "Continue Creating",
  "8bdaecf2e5": "Please enter your phone number",
  "565ae60c8a": "Enter your name",
  "f76e06d0e7": "Please enter your phone number",
  "7b0fca5255": "Please enter the verification code",
  "68026d2d25": "Welcome to the enterprise edition",
  "d25b5541be": "Create Account",
  "32cfd73733": "Please enter the name of your team, enterprise, or organization",
  "4cf83dc4a0": "Create quickly in one minute and collaborate efficiently with colleagues",
  "d320d37116": "Create teams/organization for free",
  "c54b475dd2": "User Agreement",
  "190d54e616": "Organization of {0}",
  "8c1b768ac4": "Smart verification failed",
  "d74eab0f35": "The information of your company name does not comply with the platform regulations, please modify and try again",
  "0f3d62dd4f": "The information of your name does not comply with the platform regulations, please modify and try again",
  "647cf2211b": "Creation with the current phone number is not supported, please change the phone number",
  "b63d96cdae": "The information provided does not comply with the platform regulations, please modify and try again",
  "2dbbe8e43f": "Creation with the current phone number is not supported, please modify and try again",
  "b18abc5de6": "No linked phone number",
  "f5233dae6f": "Please change the phone number to create",
  "4167c8b88d": "The current phone number may have the following situations, please try changing the phone number to create. If you have any questions, please contact customer service for consultation.",
  "a8a2433c4d": "Add by scanning WeChat code, contact customer service for consultation",
  "444a639c09": "Got it",
  "69a097057f": "The current phone number belongs to <#BB2726> virtual operator number segment <#BB2726>",
  "4370b06fd0": "The current phone number has <#BB2726> abnormal usage behavior <#BB2726>",
  "8c49e1dc4a": "Human verification required"
}